import { render, staticRenderFns } from "./CrewAdminSelectionBulk.vue?vue&type=template&id=82dca7ca"
import script from "./CrewAdminSelectionBulk.vue?vue&type=script&lang=js"
export * from "./CrewAdminSelectionBulk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports